import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "../components/common/Helmet";
import servicesData from "../components/utility/ServiceData";

interface ServiceCardProps {
    title: string;
    description: string;
    slug: string;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ title, description, slug }) => {
    return (
        <div className="bg-white shadow-md rounded-[30px] p-8 flex flex-col justify-between min-h-[300px] hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
            <div>
                <h3 className="text-2xl font-semibold mb-4 text-blue-900">{title}</h3>
                <p className="text-gray-600 leading-relaxed">{description}</p>
            </div>
            <Link to={`/services/${slug}`} className="mt-6 inline-block">
                <span className="text-white bg-blue-800 px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300 inline-flex items-center gap-2">
                    Learn more <span className="text-lg">&rarr;</span>
                </span>
            </Link>
        </div>
    );
};

const BrainServices: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        //eslint-disable-next-line
    }, [])
    const serviceEntries = Object.entries(servicesData).slice(0, 7);

    return (
        <>
            <Helmet>
                <title>Brain Surgery Services | Dr. Gangesh Gunjan | Sarvodaya Hospital</title>
                <meta name="description" content="Neurosurgical brain care in Noida & Greater Noida with 12+ years clinical experience. Evaluation and treatment for Head Injuries, Brain Tumors, Aneurysms, and Endoscopic Brain Surgeries." />
                <meta name="keywords" content="brain surgeon Noida, Dr. Gangesh Gunjan, brain surgery, skull base surgery, neurosurgery, experienced neurosurgeon, Sarvodaya Hospital" />
            </Helmet>
            <div className="bg-gradient-to-b from-gray-50 to-white">
                <div className="container mx-auto px-4 py-16 mt-28">
                    <div className="max-w-4xl mx-auto mb-16">
                        <h2 className="text-4xl font-bold mb-12 text-center text-blue-900">Brain Services</h2>
                        
                        <div className="space-y-8 text-lg leading-relaxed">
                            <p className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-blue-800">
                                Surgeries involving the brain require precise microneurosurgical skills and structured clinical evaluation. Dr. Gangesh Gunjan provides surgical expertise developed through specialized training and faculty appointments at institutions including BLK Super Speciality Hospital and Fortis Hospital.
                            </p>
                            
                            <p className="bg-white p-6 rounded-lg shadow-sm">
                                Cranial neurosurgery addresses structural, vascular, and traumatic conditions of the brain and skull base. Conditions evaluated include cranial trauma, brain tumors, aneurysms, vascular malformations, and medically refractory epilepsy.
                            </p>
                            
                            <p className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-blue-800">
                                For clinical evaluation or second opinions regarding brain conditions in Noida, Greater Noida, and Western UP, appointments can be scheduled through our hospital desk.
                            </p>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {serviceEntries.map(([slug, service]) => (
                            <ServiceCard
                                key={slug}
                                title={service.title}
                                description={service.description}
                                slug={slug}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default BrainServices;